import React from 'react';

import { Table } from 'react-bootstrap';

import Loader from '../common/Loader';
import { KYC_ADDED_OPTIONS, KYC_STANDALONE_OPTION } from '../../constants';
import { generateKYCFlowStatus, handleEnterKeyPress, isAdminView, toTitleCase } from '../../utils';

function CustomTableDetail({ children, count, index, styles = {} }) {
  return (
    <td
      className={`text-info py-2 ps-3${count !== index + 1 || ' rounded-bl border-bottom-0'}`}
      style={styles}
    >
      {children}
    </td>
  );
}

export default function KYCFlowList({
  flows,
  t,
  handleSelectFlow,
  setFlowToSubmit,
  setApprovalStatus,
  readonly,
}) {
  if (!flows) return <Loader />;

  const flowCount = Object.values(flows).length;

  return (
    <div className="border rounded mb-4">
      <Table>
        <thead>
          <tr className="py-3">
            <th
              className={`text-reg ps-3 fw-medium rounded-tl ${
                flowCount !== 0 || ' rounded-bl border-bottom-0'
              }`}
            >
              {t('applications.kycFlows.tableFields.name')}
            </th>
            <th
              className={`text-reg fw-medium rounded-tl ${flowCount !== 0 || ' border-bottom-0'}`}
            >
              {t('applications.kycFlows.tableFields.status')}
            </th>
            <th
              className={`text-reg fw-medium rounded-tl ${
                flowCount !== 0 || ' rounded-bl border-bottom-0'
              }`}
            >
              {t('applications.kycFlows.tableFields.selectedOptions')}
            </th>
            <th
              className={`text-reg fw-medium rounded-tr ${
                flowCount !== 0 || ' rounded-br border-bottom-0'
              }`}
            >
              {t('applications.kycFlows.tableFields.selectedOptions')}
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.values(flows).map((flow, index) => {
            const flowStatus = generateKYCFlowStatus(flow);
            return (
              <tr key={flow.uuid}>
                <CustomTableDetail
                  count={flowCount}
                  index={index}
                  styles={{ maxWidth: '100px', wordWrap: 'break-word', whiteSpace: 'normal' }}
                >
                  {flow.name}
                  {flow.version !== 1 ? ` v${flow.version}` : ''}
                </CustomTableDetail>
                <CustomTableDetail count={flowCount} index={index}>
                  {flowStatus.description}
                </CustomTableDetail>
                <CustomTableDetail count={flowCount} index={index}>
                  <ul className="list-unstyled m-0">
                    <li>
                      {toTitleCase(flow[KYC_STANDALONE_OPTION] ? flow[KYC_STANDALONE_OPTION] : '')}
                    </li>
                    {flow[KYC_ADDED_OPTIONS].map((option) => (
                      <li key={option}>{toTitleCase(option)}</li>
                    ))}
                  </ul>
                </CustomTableDetail>
                <td
                  className={`text-info py-2 pe-2${
                    flowCount !== index + 1 || ' rounded-br border-bottom-0'
                  }`}
                >
                  <div className="d-flex flex-column">
                    <div
                      className="py-2 text-primary-link"
                      onClick={() => handleSelectFlow(flow)}
                      role="button"
                      onKeyDown={handleEnterKeyPress(() => handleSelectFlow(flow))}
                      tabIndex={0}
                    >
                      {t('applications.kycFlows.viewDetails')}
                    </div>
                    {!readonly && flowStatus.canEdit && !isAdminView() && (
                      <div
                        role="button"
                        className="py-2 text-info-link text-caution"
                        onClick={() => setFlowToSubmit(flow.uuid)}
                        onKeyDown={handleEnterKeyPress(() => setFlowToSubmit(flow.uuid))}
                        tabIndex={0}
                      >
                        {t('applications.kycFlows.submit')}
                      </div>
                    )}
                    {!readonly && !flowStatus.canEdit && isAdminView() && !flow.approved && (
                      <div
                        role="button"
                        className="py-2 text-info-link text-success-dark"
                        onClick={() => {
                          setFlowToSubmit(flow.uuid);
                          setApprovalStatus(true);
                        }}
                        onKeyDown={handleEnterKeyPress(() => setFlowToSubmit(flow.uuid))}
                        tabIndex={0}
                      >
                        {t('applications.kycFlows.approve')}
                      </div>
                    )}
                    {!readonly && !flowStatus.canEdit && isAdminView() && !flow.approved && (
                      <div
                        role="button"
                        className="py-2 text-info-link text-caution"
                        onClick={() => {
                          setFlowToSubmit(flow.uuid);
                          setApprovalStatus(false);
                        }}
                        onKeyDown={handleEnterKeyPress(() => setFlowToSubmit(flow.uuid))}
                        tabIndex={0}
                      >
                        {t('applications.kycFlows.decline')}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
